/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../../types/schema.generated';

import gql from 'graphql-tag';
export type CalendarBookingViewQuestionAnswersBookingFragment = { questionAnswers: Array<{ questionText: string, answer: string }> };

export const CalendarBookingViewQuestionAnswersBookingFragmentDoc = gql`
    fragment CalendarBookingViewQuestionAnswersBooking on Booking {
  questionAnswers {
    questionText
    answer
  }
}
    `;